import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { JWTPayload } from 'jose';
import {
  getDecodedJWT,
  getSamlLoginUrl,
  getToken,
  setTokenCookie,
  removeTokenCookie
} from '../../auth/session';
import useRefreshToken from '../../hooks/useRefreshToken';
import ConfigHandler from './ConfigHandler';
import router from '../../router/router';
import AppSplash from '../splash/AppSplash';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function ContentRouter() {
  const content = useRoutes(router);
  const query = useQuery();
  const location = useLocation();
  const navigate = useNavigate();
  const [needRedirect, setNeedRedirect] = useState(true);
  const [decodedJwt, setDecodedJwt] = useState<JWTPayload | null>(null);
  let redirect;

  useEffect(() => {
    const token = getToken();
    const credentials = query.get('credentials');
    const finalDecodedJwt = getDecodedJWT(credentials || token);
    setDecodedJwt(finalDecodedJwt);

    if (finalDecodedJwt && credentials) {
      setTokenCookie(credentials);
    }

    redirect =
      // eslint-disable-next-line react-hooks/exhaustive-deps
      !finalDecodedJwt ||
      (finalDecodedJwt.exp &&
        Math.floor(Date.now() / 1000) > finalDecodedJwt.exp);

    if (redirect) {
      removeTokenCookie();
      window.location = getSamlLoginUrl(
        location.pathname,
        location.search
      ) as any;
    } else {
      if (credentials) {
        // The token is now in the cookie: kept in the URL, it would leak (history, shared links) and override the
        // refreshed cookie on the next reload
        const params = new URLSearchParams(location.search);
        params.delete('credentials');
        const search = params.toString();
        navigate(
          { pathname: location.pathname, search: search ? `?${search}` : '' },
          { replace: true }
        );
      }
      setNeedRedirect(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useRefreshToken();

  if (redirect || needRedirect || !decodedJwt) {
    return <AppSplash />;
  }

  return <ConfigHandler>{content}</ConfigHandler>;
}
export default ContentRouter;
